import type { FaireProductEntity } from "../../entity_types/product";

export const p_5nz2fej9s9: FaireProductEntity = {
  token: "p_5nz2fej9s9",
  type: "product",
  name: "Bauhaus Short Sleeve Sweater Tee - Aurora",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/ec66ac56fca172a74636614c701649662f4cb106881f4930d87d9aa910e1bd10.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/85b81221cd12e3b20360b9c379712fb0f78bcb5302a7127c12eb495ee9e0e076.jpeg",
    "https://cdn.faire.com/fastly/ee0927f259a3d0d2c712188506ad70e86dbed5fd80d28bf3667f4025d10e025a.jpeg",
    "https://cdn.faire.com/fastly/37c9763fe3e8c2dac336f52beb6d887ae40b61601cb5d483fb1187ecdc906448.jpeg",
    "https://cdn.faire.com/fastly/531bcddfa2b782f4075468e7660ff63a4696418b3092a3a3bfc3211fffe1cc1b.jpeg",
    "https://cdn.faire.com/fastly/4fbc5a1d898a642a38c162a8bcdaa79dd13a17fc635bb67db249286c144c7614.jpeg",
    "https://cdn.faire.com/fastly/6509a9fcd9ca02bdc80ed270ed18ab9abc97fe44e89a58dd846307c2820a06f6.jpeg",
    "https://cdn.faire.com/fastly/2b9116b794e96b5f48a7841cfffaec526f6fb2b97f53a8df7a4d4d273d38281d.jpeg"
  ],
  priceDollars: 75.6,
  description: "Our signature Bauhaus Tee, built on a bold jacquard grid — the pattern is knitted in, never printed on top. Lightweight, breathable, and easy to style.\n\n * Slightly cropped and boxy body \n * 100% Pima cotton \n * Made in Lima, Peru, with knitwear specialists we have worked with for years — Fair Trade certified ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:23.712Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
